import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { ROLES_PERMS_ACTIONS } from "../../enums";
import { ROLES_CREATE_PERMISSION } from "../../../permissions";

const RolesAndPermissionsDropdown = ({ role, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, role)}
            options={[
                {
                    value: ROLES_PERMS_ACTIONS.EDIT_ROLE,
                    label: "Edit Role",
                    baseResources: ROLES_CREATE_PERMISSION,
                },
                {
                    value: ROLES_PERMS_ACTIONS.ROLE_DESC,
                    label: "Role Description",
                    baseResources: ROLES_CREATE_PERMISSION,
                },
                {
                    value: ROLES_PERMS_ACTIONS.DELETE_ROLE,
                    label: "Delete Role",
                    baseResources: ROLES_CREATE_PERMISSION,
                },
            ]}
        />
    );
};

export default RolesAndPermissionsDropdown;
